import { Box, Divider } from '@material-ui/core';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {
  FetchWsCatalogueProductTypes,
  handleCloseWsCatalogueSideMenu,
  setCatalogueCurrentView,
} from '@src/reducers/wsCatalogue';
import {
  getCanGoBack,
  getWsCatalogueError,
  getWsCatalogueProductDetail,
} from '@src/selectors/wsCatalogue';
import type { RootState } from '@src/store/reduxstore';
import CarouselImage from '@src/utils/CarouselImage';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorView } from './ErrorView';
import { WSCatalogueProductDetail } from './types';

export type IProductDetails = WSCatalogueProductDetail & {
  error?: boolean;
  handleClose: () => void;
  handleGoBack: () => void;
};

const ProductDetailsWrapper: React.FC = () => {
  const dispatch = useDispatch();
  const productDetail = useSelector(getWsCatalogueProductDetail);
  const canGoBack = useSelector((state: RootState) =>
    getCanGoBack(state, productDetail?.id || '')
  );
  const error = useSelector(getWsCatalogueError);

  if (!productDetail) return null;

  const {
    id,
    name,
    price,
    images,
    url,
    image_url: imageUrl,
    description,
  } = productDetail;

  return (
    <ProductDetails
      id={id}
      name={name}
      price={price}
      images={images}
      url={url}
      image_url={imageUrl}
      description={description}
      error={error}
      handleClose={() => dispatch(handleCloseWsCatalogueSideMenu())}
      handleGoBack={() =>
        dispatch(
          canGoBack
            ? setCatalogueCurrentView(FetchWsCatalogueProductTypes.CART)
            : handleCloseWsCatalogueSideMenu()
        )
      }
    />
  );
};

export const ProductDetails: React.FC<IProductDetails> = ({
  name,
  description,
  price,
  images,
  url,
  error,
  handleClose,
  handleGoBack,
}) => (
  <Box margin="15px" color="var(--b2chat-gray-100)">
    <Box display="flex" alignItems="center">
      <Box onClick={handleGoBack} display="flex" style={{ cursor: 'pointer' }}>
        <ArrowBackIosIcon />
      </Box>

      <Box
        width="100%"
        display="flex"
        justifyContent="right"
        onClick={handleClose}
        style={{ cursor: 'pointer' }}
      >
        <CancelOutlinedIcon />
      </Box>
    </Box>
    {error ? (
      <ErrorView type={FetchWsCatalogueProductTypes.PRODUCT} />
    ) : (
      <>
        <CarouselImage
          images={images}
          height="160px"
          style={{
            height: '145px',
            borderRadius: '4px 4px 0px 0px',
          }}
        />
        <Box mt="15px" mb="15px" fontSize="16px" fontWeight={600}>
          {name}
        </Box>
        <Divider
          style={{
            margin: '15px 0px 15px 0px',
          }}
        />
        <Box mb="6px" fontSize="16px" fontWeight={600}>
          {price}
        </Box>
        <Box mb={1}>{description}</Box>
        <a target="_blank" rel="noreferrer" href={`${url}`}>
          {url}
        </a>
      </>
    )}
  </Box>
);

export default ProductDetailsWrapper;
